import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router} from '@angular/router';
import {AuthService} from '@shared/services/security/auth.service';

export const typeGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const router = inject(Router);
    const authService = inject(AuthService);
    const currentType = authService.getCurrentType()

    if (currentType == "") {
        router.navigate(['']);
        return false
    }

    if (currentType != route.data['type']) {
        router.navigate(['not-found']);
        return false
    }

    return true
};
